// extracted by mini-css-extract-plugin
export default {"pagination-container":"Pagination_pagination-container__mSieL","active":"Pagination_active__S8GRD","labelWithImage":"Pagination_labelWithImage__zQsKE"};